import axios from 'axios';

const settings = window.APP_SETTINGS;

export const searchCases = searchParams => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/orders`, {
		params: {
			...searchParams
		}
	});
};

export const getExpertCase = id => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/orders/${id}`);
};
